import React from 'react';
import { RichText, Image } from '@synergycms_core/components/generic';

export default props => {
  const { classes } = props;
  return (
    <div className={classes.corporateContainer}>
      <div className={classes.corporateBox}>
        <div className={classes.corporateBoxHeaderLogo}>
          <Image innerStyle={classes.corporateLogo} svg={'businessPro/bpLogo'} />
        </div>
        <div className={classes.corporateTitle}>
          <div>
            <RichText translate={true} text={'_%un universo de ventajas%_'} ucFirst={true} />
          </div>
        </div>
        <ul className={classes.corporateList}>
          {/* exclusive sales */}
          <li className={classes.corporateItem}>
            <Image innerStyle={classes.corporateIcon} svg={'businessPro/bpExclusiveSales'} />
            <RichText innerStyle={classes.corporateAdvantage} translate={true} dangerouslySetInnerHTML={'_%ofertas exclusivas%_'} ucFirst={true} />
          </li>
          {/* level up */}
          <li className={classes.corporateItem}>
            <Image innerStyle={classes.corporateIcon} svg={'businessPro/bpLevelUp'} />
            <RichText innerStyle={classes.corporateAdvantage} translate={true} dangerouslySetInnerHTML={'_%acumula estancias y sube de nivel%_'} ucFirst={true} />
          </li>
          {/* star traveler points */}
          <li className={classes.corporateItem}>
            <Image innerStyle={classes.corporateIcon} svg={'businessPro/bpEarnPoints'} />
            <RichText innerStyle={classes.corporateAdvantage} translate={true} dangerouslySetInnerHTML={'_%acumula puntos si también eres Star Traveler%_'} ucFirst={true} />
          </li>
          {/* trips advantages */}
          <li className={classes.corporateItem}>
            <Image innerStyle={classes.corporateIcon} svg={'businessPro/bpTripAdvantages'} />
            <RichText innerStyle={classes.corporateAdvantage} translate={true} dangerouslySetInnerHTML={'_%corporate en vacaciones%_'} ucFirst={true} />
          </li>
          {/* room services sales */}
          <li className={classes.corporateItem}>
            <Image innerStyle={classes.corporateIcon} svg={'businessPro/bpRestSales'} />
            <RichText innerStyle={classes.corporateAdvantage} translate={true} dangerouslySetInnerHTML={'_%oferta en restauracion%_'} ucFirst={true} />
          </li>
          {/* check in/ check out advantages */}
          <li className={classes.corporateItem}>
            <Image innerStyle={classes.corporateIcon} svg={'businessPro/bpEarlyLateCheck'} />
            <RichText innerStyle={classes.corporateAdvantage} translate={true} dangerouslySetInnerHTML={'_%early checkin%_'} ucFirst={true} />
          </li>
        </ul>
        {/* conditions list */}
        <ol className={classes.conditionsList}>
          <li>
            <RichText innerStyle={classes.corporateAdvantage} translate={true} dangerouslySetInnerHTML={'_%solo en hoteles seleccionados%_'} ucFirst={true} />
          </li>
          <li>
            <RichText innerStyle={classes.corporateAdvantage} translate={true} dangerouslySetInnerHTML={'_%bajo disponibilidad%_'} ucFirst={true} />
          </li>
        </ol>
      </div>
    </div>
  );
};
